module.exports = __webpack_public_path__ + "static/media/bolso (22).db90888d.jpg";